"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ToastBody: function() {
        return _index.ToastBody;
    },
    renderToastBody_unstable: function() {
        return _index.renderToastBody_unstable;
    },
    toastBodyClassNames: function() {
        return _index.toastBodyClassNames;
    },
    useToastBodyStyles_unstable: function() {
        return _index.useToastBodyStyles_unstable;
    },
    useToastBody_unstable: function() {
        return _index.useToastBody_unstable;
    }
});
const _index = require("./components/ToastBody/index");
